import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IAutoIngestJobInfo } from 'rev-shared/media/IAutoIngestJobInfo';
import { MediaSettingsService } from '../MediaSettings.Service';
import styles from './MediaFeatures.module.less';

export enum AutoInjestType {
	WEBEX,
	ZOOM,
}

@Component({
	selector: 'auto-ingest-logs',
	templateUrl: './AutoIngestLogs.Component.html',
	host: {
		class: 'device-logs-modal'
	},
	standalone: false
})

export class AutoIngestLogsComponent implements OnInit {
	@Input() public accountId: string;
	@Input() public siteSettingsId: string;
	@Input() public type: AutoInjestType;

	public readonly styles = styles;

	public logs: IAutoIngestJobInfo[] = [];
	public status: { [status: string]: boolean };

	constructor(
		public MediaSettingsService: MediaSettingsService,
		public bsModalRef: BsModalRef
	) {
	}

	public ngOnInit(): void {
		this.status = { isLoading: true };
		this.MediaSettingsService.getAutoIngestLog(this.accountId, this.type, this.siteSettingsId)
			.then(result => this.logs = result)
			.finally(() => this.status = { active: true });
	}

	public close(): void {
		this.bsModalRef.hide();
	}
}
